import { Helmet } from "react-helmet-async";

function ContactPageHelmetComponent() {
  const title =
    "Tapahtumatekniikan varaus ja yhteydenotto | Spiderlegs Productions";

  const description =
    "Tee varaus tai tarjouspyyntö äänentoistosta, valotekniikasta, peräkärrystä ja muusta vuokrattavasta tapahtumatekniikasta Spiderlegs Productionsilta.";

  const url = "https://spiderlegsproductions.com/tee-varaus/";

  const image = "https://spiderlegsproductions.com/assets/laitteidenvaraus.png";

  return (
    <Helmet>
      {/* Title */}
      <title>{title}</title>

      {/* Meta description */}
      <meta name="description" content={description} />

      {/* Keywords: ei kriittinen Googlelle, mutta pidetään sivun aiheeseen liittyvänä */}
      <meta
        name="keywords"
        content="tapahtumatekniikan varaus, äänentoiston vuokraus, valotekniikan vuokraus, peräkärryn vuokraus, laitevuokraus, vuokrakalusto, Spiderlegs Productions"
      />

      {/* Author */}
      <meta name="author" content="Spiderlegs Productions" />

      {/* Canonical */}
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Spiderlegs Productions" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}

export default ContactPageHelmetComponent;